import { createSlice, createAsyncThunk, SerializedError } from '@reduxjs/toolkit';

import { TrailId } from '../../../types/trails';
import { editItemsRequest, EditItemStatus, EditItemType } from '../../../utils/requests/editItemsRequests';

export type PendingTrailEditsState = {
  trailIds: TrailId[];
  error: SerializedError;
};

export const initialState: PendingTrailEditsState = {
  trailIds: [],
  error: null
};

export const getPendingTrailEdits = createAsyncThunk('pendingTrailEdits/get', async (userId: number) => {
  const trailEdits = await editItemsRequest(userId, EditItemType.Trail, EditItemStatus.Pending);
  return trailEdits.editItems.map(editItem => editItem.targetObjectId);
});

export const pendingTrailEditsSlice = createSlice({
  name: 'pendingTrailEdits',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getPendingTrailEdits.fulfilled, (state, action) => {
        state.trailIds = action.payload;
      })
      .addCase(getPendingTrailEdits.rejected, (state, action) => {
        state.error = action.error;
      });
  }
});

export default pendingTrailEditsSlice.reducer;
